module.exports = __webpack_public_path__ + "img/dz.4450a753.svg";